// extracted by mini-css-extract-plugin
export default {"formItem":"styles_formItem__Hxjdn","text":"styles_text__kqbbr","noChildren":"styles_noChildren__Ln6cj"};